import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TLIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TL" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#E31D1C" stroke="#F7FCFF" d="M16.5-.5v13h-17v-13h17Z" />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m0 0 12 6-12 6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="m0 0 8 6-8 6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="m3.324 7.204-1.01 1.05-.105-1.492L.92 5.968l1.343-.42.22-1.48.93 1.171 1.355-.363-.7 1.387.681 1.339-1.426-.398Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
